import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
import { formatNumber } from 'common/helpers/formatting';


const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
}));

const AtkvaediCountCard = props => {
  const { title, count, avatarLetter } = props;
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Grid container justify="space-between">
          <Grid item>
            <Typography color="textSecondary" variant="body2" style={{ fontWeight: '700' }} gutterBottom>
              {title}
            </Typography>
            <Typography variant="h3">{count ? formatNumber(count) : 0}</Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar} color="secondary">
              {avatarLetter}
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AtkvaediCountCard;